import { render, staticRenderFns } from "./PageLanguage.vue?vue&type=template&id=21cf1adb&scoped=true"
import script from "./PageLanguage.vue?vue&type=script&lang=js"
export * from "./PageLanguage.vue?vue&type=script&lang=js"
import style0 from "./PageLanguage.vue?vue&type=style&index=0&id=21cf1adb&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21cf1adb",
  null
  
)

export default component.exports